import * as React from "react";
import style from "./Corona.css";
import Button from "../Button";

const locales = ["en", "nl", "it", "fr", "es", "de", "lt"];

const EMAIL_ANCHOR = "<a href='mailto:treatwell@jobs.workablemail.com?" +
  "Subject=Treatwell%20Talent%20Pool%20Application" +
  "&Body=Hey, %0D%0A%0D%0AThanks for your interest in Treatwell, we’re excited to have you join our talent pool!" +
  "%0D%0APlease attach a copy of your CV and fill in the below information so we can get back to you.%0D%0A%0D%0A" +
  "Speak soon,%0D%0ATreatwell Talent Team%0D%0A%0D%0A%0D%0AFull Name: %0D%0A%0D%0AEmail: %0D%0A%0D%0A" +
  "Telephone: %0D%0A%0D%0APlease confirm the Treatwell location you’d like to work in:" +
  " %0D%0A(United Kingdom / Ireland/ The Netherlands / Spain / France / Italy / Germany / Lithuania)" +
  "%0D%0A%0D%0APlease specify the area(s) of the business you’re interested in:" +
  " %0D%0A(Sales / Account Management/ Business Insights/ Marketing / Customer Experience /" +
  " Technology / Marketplace Content / Finance / Legal / People Team) %0D%0A%0D%0APlease specify all languages you" +
  " speak and write in with professional proficiency:%0D%0A%0D%0ASalary expectations:" +
  " %0D%0A%0D%0ACover letter (optional)'>treatwell@jobs.workablemail.com</a>";

const copyByLocale = {
  en: "At Treatwell we are closely monitoring the development of the Coronavirus COVID-19." +
    " Based on this and with everyone's best interests in mind we've decided to" +
    " reduce recruitment until we have a better understanding of how this will affect us all.",
  nl: "Treatwell volgt de ontwikkelingen rondom het coronavirus (COVID-19) op de voet." +
    " Met ieders belangen in gedachten hebben wij besloten de werving van nieuw personeel" +
    " op een laag pitje te zetten tot wij beter begrijpen hoe dit ons allemaal zal beïnvloeden.",
  it: "Treatwell monitora costantemente l'evolversi della situazione relativa al virus Covid-19." +
    " Considerata l'attuale situazione di criticità e per la sicurezza di tutti," +
    " abbiamo deciso di ridurre le assunzioni fino a quando non avremo un quadro" +
    " più chiaro dell'impatto da essa derivante. ",
  fr: "Chez Treatwell, nous suivons de près l'évolution du Coronavirus (COVID-19)." +
    " En réponse à cela et dans l'intérêt de tous, nous avons décidé de réduire notre activité" +
    " de recrutement pour une durée indeterminée.",
  es: "En Treatwell estamos siguiendo de cerca el desarrollo del Coronavirus COVID-19." +
    " En base a esto, y con los intereses de todos en mente, hemos decidido" +
    " posponer el reclutamiento hasta que comprendamos mejor cómo nos afectará a todos.",
  de: "Treatwell verfolgt die Entwicklung des Coronavirus COVID-19 sehr genau." +
    " Deshalb haben wir beschlossen, Neueinstellungen zu reduzieren, bis wir" +
    " besser einschätzen können, wie sich die Lage auf uns alle auswirken wird.",
  lt: "Treatwell atidžiai seka koronaviruso COVID- 19 pandemijos evoliuciją." +
    " Remiantis tuo ir visų mūsų interesais mes laikinai sulėtinome įdarbinimo procesą" +
    " iki kol geriau suprasime kaip dabartinė situacija paveiks mus visus."
};

const ctaByLocale = {
  en: "During this time we have opened up our talent pool where you can submit your details," +
    " receive regular updates from us and be the first to know about available positions." +
    " Send your CV to " + EMAIL_ANCHOR +
    " including the department/role of interest in the body of your email and our team will be in touch. ",
  nl: "Tijdens deze periode openen wij onze talent pool, waar je jouw contactgegevens kunt" +
    " achterlaten. Wij houden je dan op de hoogte van de ontwikkelingen - en je bent de" +
    " eerste die het hoort als wij weer vacatures hebben." +
    " Stuur je CV naar " + EMAIL_ANCHOR +
    " en vermeld in de e-mail in welke rol(len)" +
    " je interesse hebt - dan neemt ons team contact met je op. ",
  it: "Abbiamo creato una sezione speciale (talent pool) dove potrai inviare i tuoi dati, ricevere" +
    " aggiornamenti periodici e conoscere in anteprima le offerte di lavoro disponibili." +
    " Invia il tuo CV a " + EMAIL_ANCHOR + " indicando all’interno dell’e-mail" +
    " il ruolo o l’area d’interesse e il nostro team ti contatterà appena possibile.",
  fr: "Durant cette période, nous avons ouvert une section talents où vous pouvez entrer vos détails," +
    " recevoir des mises à jour régulières de notre part et être les premiers avertis des emplois disponibles." +
    " Envoyez votre CV à l'adresse " + EMAIL_ANCHOR +
    " en communiquant le secteur d'activité/poste qui vous intéresse dans le corps de l'e-mail." +
    " Notre équipe vous contactera au plus vite.",
  de: "Während dieser Zeit nehmen wir trotzdem gerne deine Daten in unseren Talentpool auf." +
    " So erhältst du regelmäßige Updates zu den vakanten Stellen. Bitte sende deinen Lebenslauf" +
    " mit der gewünschten Abteilung/Rolle an " + EMAIL_ANCHOR +
    " und unser Team wir" +
    "d sich mit dir in Verbindung setzen.",
  es: "Durante este tiempo, hemos abierto nuestro grupo de talentos donde puedes enviar tus datos," +
    " recibir actualizaciones periódicas por nuestra parte y ser el primero en conocer las vacantes disponibles." +
    " Envía tu CV a " + EMAIL_ANCHOR + " incluyendo el departamento / función de interés en el cuerpo de" +
    " su correo electrónico y nuestro equipo se pondrá en contacto contigo. ",
  lt: "Šiuo metu mes laukiame visų talentų besidominčių karjera Treatwell laiškų." +
    " Mes informuosime tave apie visas naujienas ir tu būsi pirmas, kuris sužinos" +
    " apie laisvas pozijas. Tavo CV lauksime adresu " + EMAIL_ANCHOR +
    " Laiške nurodyk koks departamentas/pozicija tave domina ir mūsų komanda susisieks su tavimi."
};



export const Corona = ({ locale, onClose, onClick }) => {
  return (
    <div className={style.coronaWrapper}>
      <span className={style.closeButton} onClick={onClose}>&#10005;</span>
      <img
        alt={"Back Soon"}
        src="/img/careers-closed-sign.gif"
        width="150px"
        className={style.coronaGif}
      />
      <div className={style.coronaInfo}>
        <p>
          {copyByLocale[locale]}
        </p>
        <p dangerouslySetInnerHTML={{
          __html: ctaByLocale[locale]
        }}/>
      </div>
      <LanguageSelector
        selectedLanguage={locale}
        onClick={onClick}
      />
      <Button
        onClick={onClose}
        label={"See available jobs"}
        styles={{
          borderRadius: "0px",
          padding: "16px",
          backgroundColor: "#002161",
        }}
      />
    </div>
  );
};

export const LanguageSelector = ({ selectedLanguage, onClick }) => {
  return (
    <div className={style.languageSelector}>
      {locales.map((locale) => {
        return (
          <span
            key={locale}
            className={`${style.localeButton} ${selectedLanguage === locale ? style.selectedLocale : ""}`}
            onClick={() => onClick(locale)}
          >
            {locale}
          </span>
        );
      })}
    </div>
  );
};



// WEBPACK FOOTER //
// ./component/Corona/index.js